export { default } from './RemoveCommentLink'
